import { Injectable } from '@angular/core';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  readonly firebaseApp: FirebaseApp = initializeApp(environment.firebaseConfig);
  public fire_messaging = getMessaging(this.firebaseApp);
}
